export const queryGetOrderCount = `
  query Order($orderId: ID!) {
  order(id: $orderId) {
    documentCount
    itemCount
    packageShipmentCount
    proofOfPaymentCount
    qualityControlCount
  }
}
`